// Module
var code = "<style>#analytics-page{margin:-20px;margin-top:-25px}#analytics-page #report-container{height:90vh;width:100%}</style> <div id=\"analytics-page\"> <div id=\"report-container\"></div> </div>";
// Exports
export default code;